import React, { useEffect, useState } from 'react';
import { PH3Text, H2Text, Input, InputWrapper, LabelText, Text, FlexContainer } from "../../design";
import { Controller } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import Select from 'react-select'
import { COUNTRY_PHONE_CODE, EMAIL } from "../../appconstants";
import NumberFormat from "react-number-format";
import { isValidPhoneNumber } from 'libphonenumber-js';
import { Col, Row } from "react-awesome-styled-grid";
import { useRef } from 'react';
import { useDispatch } from 'react-redux';
import { setCustomerDetails } from '../../redux/customerDetailsInfo';

type Props = {
  control: any,
  errors: any,
  readOnly: Array,
  validation: boolean,
  requiredPhone: boolean,
  validateInvoice: boolean,
  payment: Object,
  watch: Function,
}

const Customer = (props: Props) => {
  const { control, errors, readOnly, requiredPhone, validateInvoice, payment, watch, setValue } = props;
  const [validation, setValidation] = useState(true);
  const [inputPhoneReadOnly, setInputPhoneReadOnly] = useState(false);
  const BACKGROUND_COLOR = '#E8ECED';
  const COLOR = '#6A6A6A';
  const dispatch = useDispatch();

  useEffect(() => {
    setValidation(props.validation)
  }, [props.validation]);

  useEffect(() => {
    setInputPhoneReadOnly(readOnly && readOnly.includes("phone"))
  }, [props.readOnly]);

  // THIS FUNCTIONALITY IS WRITTEN TO UPDATE THE CHANGED CUSTOMER VALES IN OTHER PAYMENT METHODS
  const watchedName = watch("cname");
  const watchedEmail = watch("email");
  const watchedPhone = watch("phone");
  const watchedCallingCode = watch("countryCallingCode");
  const callingCodeValue = watchedCallingCode?.value;

  const previousName = useRef();
  const previousEmail = useRef();
  const previousPhone = useRef();
  const previousCallingCodeValue = useRef();

  // Combined effect for all three fields
// Combined effect for all three fields
  useEffect(() => {
    // Check if any value has actually changed
    const hasNameChanged = watchedName !== previousName.current;
    const hasEmailChanged = watchedEmail !== previousEmail.current;
    const hasPhoneChanged = watchedPhone !== previousPhone.current;
    const hasCallingCodeChanged = callingCodeValue !== previousCallingCodeValue.current;

    if (hasNameChanged || hasEmailChanged || hasPhoneChanged || hasCallingCodeChanged) {
      // 1. Update the refs
      previousName.current = watchedName;
      previousEmail.current = watchedEmail;
      previousPhone.current = watchedPhone;
      previousCallingCodeValue.current = callingCodeValue; // Store the primitive value

      // 2. Dispatch to Redux
      const fullPhone = callingCodeValue
        ? `${callingCodeValue}${watchedPhone || ""}`
        : watchedPhone || "";
      
      dispatch(setCustomerDetails({ name: watchedName, email: watchedEmail, phoneNumber: fullPhone }));
    }
  }, [watchedName, watchedEmail, watchedPhone, callingCodeValue, dispatch]);

  const isNameValidate = (data: string) => {
    const custometName = data && data.trim();
    const count = custometName.length;
    if (count < 5) {
      return "The name should be minimum 5 characters";
    }
  };

  const isPhoneNumberValidate = (data: string) => {
    const cuntryCode = control.getValues().countryCallingCode.value;
    const phoneNum = control.getValues().phone;
    if (data) {
      if (!isValidPhoneNumber(`${cuntryCode}${phoneNum}`)) {
        return 'The phone number is invalid';
      }
    }
  };

  const customStyles = {
    container: base => ({
      ...base,
      width: '100%',
      height: '41px',
      // marginTop: '8px',
      marginBottom: '8px',
      borderRadius: '10px',
    }),
    control: base => ({
      ...base,
      height: '41px',
      minHeight: '41px',
      border: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
      marginTop: '8px',
      width: '100%',
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    })
  };

  const phoneCustomStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important',
      // maxWidth: '100px !important',
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      width: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
    }),
  };

  const disableStyles = {
    container: base => ({
      height: '41px',
      width: '100px !important',
      // maxWidth: '100px !important',
    }),
    control: base => ({
      ...base,
      height: '39px',
      minHeight: '39px',
      // width: '100px !important',
      border: 'none',
      borderRight: '1px solid #CCCCCC',
      boxShadow: 'none',
      borderColor: '#CCCCCC !important',
      background: '#E8ECED',
      color: '#6A6A6A'
    }),
  };

  const customInputStyle = {
    background: 'white',
    // color: 'black',
    borderColor: '#CCCCCC',
    width: '100%',
    height: '41px',
    paddingLeft: '15px',
  };

  const customLabelStyle = {
    color: 'black'
  };

  const customRowFlexContainerProps = {
    xs: '100%',
    md: '100%',
    gap: '5%',
  };

  const customColFlexContainerProps = {
    xs: '100%',
    md: '47.5%',
    flexDirection: 'col',
  };

  return (
  <FlexContainer>
    <FlexContainer {...customRowFlexContainerProps}>
      <PH3Text className="my-3 mx-0 p-0" fontWeight="bold">CUSTOMER DETAILS</PH3Text>
    </FlexContainer>
    <FlexContainer {...customRowFlexContainerProps}>
      <FlexContainer {...customColFlexContainerProps}>
        {
          payment && payment.account && payment.account.gid === 'account-25729ddf59914c9abcb41a107d824330' ? (
            <LabelText style={{...customLabelStyle}}>
              Name / Organization Name <span style={{ color: 'red' }}>*</span>
            </LabelText>
          ) : (
            <LabelText style={{...customLabelStyle}}>
              Name <span style={{ color: 'red' }}>*</span>
            </LabelText>
          )
        }
        <Controller
          color={errors.cname ? "red" : "inherit"}
          marginBottom="0px"
          control={control}
          name="cname"
          placeholder="Enter your name"
          rules={validation && {
            required: 'Name is required',
            validate: isNameValidate,
          }}
          as={<Input
              readOnly={readOnly && readOnly.includes("name")}
              style={{
                ...customInputStyle,
                background: (readOnly && readOnly.includes("name")) ? BACKGROUND_COLOR : customInputStyle.background,
                color: (readOnly && readOnly.includes("name")) ? COLOR : customInputStyle.color,
              }}
          />}
        />
        <ErrorMessage
          errors={errors}
          name="cname"
          render={({ message }) => (
            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
          )}
        />
      </FlexContainer>
      <FlexContainer {...customColFlexContainerProps}>
        <LabelText style={{...customLabelStyle}}>
          E-Mail <span style={{ color: 'red' }}>*</span>
        </LabelText>
        <Controller
          marginBottom="0px"
          defaultValue={""}
          color={errors.email ? "red" : "inherit"}
          control={control}
          name="email"
          placeholder="Enter your email address"
          rules={validation && {
            required: 'Email is required',
            pattern: {
              value: EMAIL.NEW_EMAIL_REGEX1,
              message: EMAIL.DEFAULT_ERROR_MESSAGE,
            },
          }}
          as={<Input
            type="email"
            readOnly={readOnly && readOnly.includes("email")}
            style={{
              ...customInputStyle,
              background: (readOnly && readOnly.includes("email")) ? BACKGROUND_COLOR : customInputStyle.background,
              color: (readOnly && readOnly.includes("email")) ? COLOR : customInputStyle.color,
            }}
          />}
        />
        <ErrorMessage
          errors={errors}
          name="email"
          render={({ message }) => (
            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
          )}
        />
      </FlexContainer>
    </FlexContainer>
    <FlexContainer {...customRowFlexContainerProps}>
      <FlexContainer {...customColFlexContainerProps}>
        <LabelText style={{...customLabelStyle}}>
          Phone {validateInvoice ? "(Optional)" : null} { validateInvoice ? null : <span style={{ color: 'red' }}>*</span> }
        </LabelText>
        <InputWrapper
          className="row"
          display="flex"
          marginTop="8px"
          // borderRadius="4px"
          // width="299px"
          style={{
            ...customInputStyle,
            paddingLeft: 0,
          }}
        >
          <Controller
            defaultValue={""}
            color={errors.countryCallingCode ? "red" : "inherit"}
            marginBottom="0px"
            control={control}
            name="countryCallingCode"
            placeholder="select"
            rules={validation && requiredPhone && {
              required: 'Calling Code is required'
            }}
            as={<Select
              className="col-4 px-0 border-0"
              isSearchable={!inputPhoneReadOnly}
              menuIsOpen={inputPhoneReadOnly ? false : undefined}
              theme={theme => ({
                ...theme,
                borderRadius: "4px 0 0 4px",
                boxShadow: 0,
              })}
              getOptionLabel={(option) => option.value}
              styles={inputPhoneReadOnly ? disableStyles : phoneCustomStyles}
              options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
          />
          {
            (validation && requiredPhone) ? (
              <Controller
                className="col"
                defaultValue={""}
                color={errors.phone ? "red" : "inherit"}
                border="0px !important"
                marginBottom="0px"
                marginTop="0px"
                marginLeft="0px"
                paddingRight="0"
                control={control}
                name="phone"
                rules={validation && requiredPhone && {
                  required: 'Phone number is required',
                  validate: isPhoneNumberValidate
                }}
                as={<NumberFormat
                  type="tel"
                  allowNegative={false}
                  decimalScale={0}
                  readOnly={inputPhoneReadOnly}
                  borderRadius="none"
                  height="39px"
                  style={{
                    ...customInputStyle,
                    height: '39px',
                    background: (inputPhoneReadOnly) ? BACKGROUND_COLOR : customInputStyle.background,
                    color: (inputPhoneReadOnly) ? COLOR : customInputStyle.color,
                  }}
                />}
                placeholder="Enter your phone number"
                customInput={Input}
              />
            ) : (
              <Controller
                className="col"
                defaultValue={""}
                color={errors.phone ? "red" : "inherit"}
                border="0px !important"
                marginBottom="0px"
                marginTop="0px"
                marginLeft="0px"
                paddingRight="0"
                control={control}
                name="phone"
                rules={{
                  validate: isPhoneNumberValidate,
                }}
                as={<NumberFormat
                  type="tel"
                  allowNegative={false}
                  decimalScale={0}
                  readOnly={inputPhoneReadOnly}
                  borderRadius="none"
                  height="39px"
                  style={{
                    ...customInputStyle,
                    height: '39px',
                    background: (inputPhoneReadOnly) ? BACKGROUND_COLOR : customInputStyle.background,
                    color: (inputPhoneReadOnly) ? COLOR : customInputStyle.color,
                  }}
                />}
                placeholder="Enter your phone number"
                customInput={Input}
              />
            )
          }

        </InputWrapper>
        <ErrorMessage
          errors={errors}
          name="phone"
          render={({ message }) => (
            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
          )}
        />
        <ErrorMessage
          errors={errors}
          name="countryCallingCode"
          render={({ message }) => (
            <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
          )}
        />
      </FlexContainer>
    </FlexContainer>
  </FlexContainer>
  );
};

export default Customer;
